import React, { useEffect } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { TabPane, Tab } from 'semantic-ui-react';

import { getUser, updateUser } from '@plone/volto/actions/users/users';
import { Form } from '@plone/volto/components/manage/Form';
import { getBaseUrl } from '@plone/volto/helpers/Url/Url';
import { usePrevious } from '@plone/volto/helpers/Utils/usePrevious';

import { getLocations } from '../../../actions';
import useToast from '../../../helpers/useToast';
import FBCLoader from '../../FBCLoader/FBCLoader';
import { LocationsTable } from './LocationsTable';
import jwtDecode from 'jwt-decode';

export const User = ({ intl, dispatch, location }) => {
  const token = useSelector((state) => state.userSession.token);
  const user = useSelector((state) => state.users.user);
  const update = useSelector((state) => state.users.update);
  const get = useSelector((state) => state.users.get);
  const userschema = useSelector((state) => state.userschema);
  const locations_get = useSelector((state) => state.locations.get);
  const location_delete = useSelector((state) => state.location.delete);
  const prevdelete = usePrevious(location_delete);

  const userId = token ? jwtDecode(token).sub : '';

  const messages = defineMessages({
    myLocations: {
      id: 'myLocations',
      defaultMessage: 'My locations',
    },
    myData: {
      id: 'myData',
      defaultMessage: 'My data',
    },
    save: {
      id: 'save',
      defaultMessage: 'Save',
    },
    editInformation: {
      id: 'editInformation',
      defaultMessage: 'Edit information',
    },
  });

  useEffect(() => {
    dispatch(getUser(userId));
    dispatch(getLocations(getBaseUrl(location.pathname)));
  }, [dispatch, userId, location.pathname]);

  useEffect(() => {
    prevdelete?.loading &&
      location_delete.loaded &&
      dispatch(getLocations(getBaseUrl(location.pathname)));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, location_delete.loading]);

  const onSubmit = (data, userId, dispatch) => {
    // We don't want the user to change his login name/username or the roles
    // from this form
    // Backend will complain anyways, but we clean the data here before it does
    delete data.id;
    delete data.username;
    delete data.roles;
    dispatch(updateUser(userId, data));
  };

  const panes = [
    {
      menuItem: intl.formatMessage(messages.myLocations),
      render: () => (
        <TabPane>
          <h4>
            <strong>
              <FormattedMessage
                id="La información solicitada tiene que ser adminitada por el administrador del sitio."
                defaultMessage="La información solicitada tiene que ser adminitada por el administrador del sitio."
              />
            </strong>
          </h4>
          <p>
            <FormattedMessage
              id="Una vez aceptada la petición recibiras un email y podras ver toda la información de cada localización admitida."
              defaultMessage="Una vez aceptada la petición recibiras un email y podras ver toda la información de cada localización admitida."
            />
          </p>
          <LocationsTable
            locations={locations_get.data || []}
            dispatch={dispatch}
            loading={locations_get.loading}
            isManager={false}
          />
        </TabPane>
      ),
    },
    {
      menuItem: intl.formatMessage(messages.myData),
      render: () => (
        <TabPane>
          {(userschema.loading || get.loading || update.loading) && (
            <FBCLoader />
          )}

          <div className="user-data-form">
            {userschema.loaded &&
              userschema.userschema?.fieldsets?.length > 0 && (
                <Form
                  title={intl.formatMessage(messages.editInformation)}
                  className="user-data-form"
                  formData={user}
                  schema={{
                    ...userschema.userschema,
                    properties: {
                      ...userschema.userschema.properties,
                      fullname: {
                        ...userschema.userschema.properties.fullname,
                        description: false,
                      },
                      email: {
                        ...userschema.userschema.properties.email,
                        description: false,
                      },
                    },
                  }}
                  onSubmit={(event) => onSubmit(event, userId, dispatch)}
                  submitLabel={intl.formatMessage(messages.save)}
                />
              )}
          </div>
        </TabPane>
      ),
    },
  ];
  return (
    <>
      {useToast('users.update')}
      {useToast('location.delete')}
      <Tab panes={panes} />
    </>
  );
};
